<template>
  <el-menu :default-active="$route.path" class="app-slide" router>
    <el-submenu
      v-for="route in menuRoutes"
      :key="route.path"
      :index="route.redirect"
    >
      <template #title>
        <span>{{ route.meta.title }}</span>
      </template>
      <el-menu-item
        v-for="child in route.children.filter((child) => child.meta.showMenu)"
        :key="child.path"
        :index="child.path"
      >
        {{ child.meta.title }}
      </el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
// import router from './router'
export default {
  name: "SlideBar",
  data() {
    return {
      openedArray: [],
    };
  },
  computed: {
    menuRoutes() {
      const routes = this.$router.options.routes.filter((route) => {
        if (route.meta && route.meta.showMenu) {
          const isAdmin = this.$store.getters.isAdmin;
          if (route.meta.title == "系统管理" && !isAdmin) {
            return false;
          }
          return true;
        } else {
          return false;
        }
      });
      return routes;
      // return this.$router.options.routes.filter(
      //   (route) => route.meta && route.meta.showMenu
      // );
    },
  },
  mounted() {
    // this.openedArray = this.menuRoutes[0].children
    console.log(this.$route.path);
  },
  methods: {
    handleOpen() {},
    handleClose() {},
  },
};
</script>

<style lang="scss" scoped>
.app-slide {
  height: 100%;
  //   height: calc(100vh - 100px);
  width: 200px;
}
</style>
